import { InjectionToken } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';

/** Narrow surface of the Datadog Browser RUM SDK used by `DatadogRumFacade`. */
export interface DatadogRumSdkLike {
  setUser(user: Record<string, unknown>): void;
  clearUser(): void;
  setUserProperty(key: string, value: unknown): void;
  addAction(name: string, context?: object): void;
  addError(error: unknown, context?: object): void;
  setGlobalContextProperty(key: string, value: unknown): void;
  removeGlobalContextProperty(key: string): void;
  startView(name: string | { name: string }): void;
}

/** Resolves to the real `datadogRum` singleton; tests override it with a spy. */
export const DATADOG_RUM_SDK = new InjectionToken<DatadogRumSdkLike>('DATADOG_RUM_SDK', {
  providedIn: 'root',
  factory: () => datadogRum,
});
